import { render, staticRenderFns } from "./genomicsSearchTools.vue?vue&type=template&id=4936f694&scoped=true"
import script from "./genomicsSearchTools.vue?vue&type=script&lang=js"
export * from "./genomicsSearchTools.vue?vue&type=script&lang=js"
import style0 from "./genomicsSearchTools.vue?vue&type=style&index=0&id=4936f694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4936f694",
  null
  
)

export default component.exports